export enum EventType {
  ERROR = "pe",
  CUSTOM_EVENT = "ce",
  PV = "pv",
}

export interface Event {
  business?: {
    name?: string; // 业务名称/应用名称
    url?: string; // 业务URL
    version?: string; // 业务版本
    channel?: string; // 业务渠道
    position?: string;
    data?: any; // 其他业务相关数据
  };
  event: {
    name: string; // 事件名称
    type: EventType; // 事件类型
    time?: string; // 事件发生时间
    url?: string;
    data?: {
      brief?: string; // 错误事件必填，md5(stack)
      stack?: string; // 错误事件栈
      [key: string]: any;
    }; // 其他事件相关信息
  };
  device?: {
    // 设备信息
    brand?: string; // 设备品牌
    model?: string; // 设备型号
    os?: string; // 操作系统
    version?: string; // 设备版本
    battery?: string; //电量信息
    userAgent?: string; // Webview 容器信息
    screen?: string; // 屏幕分辨率
    uuid?: string; // 设备唯一ID
    cpu?: string; // CPU 信息
    memory?: string; // 内存大小
    data?: any; // 其他设备信息
    [key: string]: any;
  };
  sdk?: {
    // SDK 信息
    version: string; // SDK 版本
    data?: any; // 其他 SDK 信息
  };
}
